import { Zap, Crown, Star, Book, Layers } from "lucide-react";

const SubscriptionCard = ({
  title,
  price,
  features,
  buttonText,
  onClick,
  isCurrent,
  disabled,
}) => {
  const getIcon = () => {
    if (title.includes("رایگان"))
      return <Zap className="text-sky-500 w-8 h-8" />;
    if (title.includes("پایه"))
      return <Star className="text-amber-500 w-8 h-8" />;
    if (title.includes("پیشرفته"))
      return <Crown className="text-purple-500 w-8 h-8" />;
    if (title.includes("آزمون"))
      return <Book className="text-emerald-500 w-8 h-8" />;
    return <Layers className="text-gray-400 w-8 h-8" />;
  };

  return (
    <div
      className={`bg-white rounded-3xl border transition-all duration-300 flex flex-col justify-between overflow-hidden group shadow-sm hover:shadow-md ${
        isCurrent ? "border-indigo-500 shadow-lg" : "border-gray-100"
      }`}
    >
      {/* محتوای کارت */}
      <div className="p-6 flex flex-col items-start">
        <div className="flex items-center gap-3 mb-3">
          <div className="p-2 bg-gradient-to-br from-indigo-100 to-purple-100 rounded-xl">
            {getIcon()}
          </div>
          <h3 className="font-extrabold text-lg text-gray-800 group-hover:text-indigo-600 transition">
            {title}
          </h3>
        </div>

        <p className="text-2xl font-bold text-indigo-600 mb-4 tracking-tight">
          {price}
        </p>

        <ul className="space-y-2 text-sm text-gray-700 leading-relaxed">
          {features.map((f, i) => (
            <li key={i} className="flex items-start gap-2">
              <span className="w-1.5 h-1.5 mt-2 bg-indigo-500 rounded-full flex-shrink-0" />
              <span>{f}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* دکمه */}
      <div className="p-6 pt-0">
        {isCurrent ? (
          <div className="w-full py-2.5 text-center font-semibold text-indigo-700 bg-indigo-50 border border-indigo-100 rounded-xl">
            پلن فعلی شما
          </div>
        ) : (
          <button
            onClick={!disabled ? onClick : undefined}
            disabled={disabled}
            className={`w-full py-2.5 font-semibold rounded-xl transition-all duration-200 ${
              disabled
                ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                : "text-white bg-gradient-to-r from-indigo-500 to-purple-600 shadow-md hover:shadow-lg hover:scale-[1.02]"
            }`}
          >
            {buttonText}
          </button>
        )}
      </div>
    </div>
  );
};

export default SubscriptionCard;
